<template lang="pug">
div
  el-table(
    :data="listagem"
    style="width: 100%"
    border
  )
    el-table-column(
      v-if="tipoCodigoAtividade !== 'OUTRAS_ATIVIDADES'"
      prop="descTipo"
      label="Tipo"
      :formatter="formataDesc"
    )
    el-table-column(
      v-if="tipoCodigoAtividade === 'OUTRAS_ATIVIDADES'"
      prop="tipo"
      label="Tipo"
      :formatter="formataDescOutrasAtividades"
    )
    el-table-column(
      v-if="tipoCodigoAtividade === 'SEMOVENTES'"
      prop="numeroCabecas"
      label="Número de Cabeças"
    )
    el-table-column(
      v-if="tipoCodigoAtividade !== 'SEMOVENTES'"
      prop="area"
      label="Área"
      :formatter="formatarAreaEdificacao"
    )
    el-table-column(
      v-if="tipoCodigoAtividade === 'OUTRAS_ATIVIDADES'"
      label="Observações"
      prop="observacoes"
    )
    el-table-column(
      label="Ações"
      width="100"
      align="center"
    )
      template(slot-scope="scope")
        el-button(
          type="text"
          @click="handleDelete(scope.$index, tipoCodigoAtividade)"
        )
          i(class="el-icon-close" style="color: red;")
</template>

<script>
import { mapActions } from 'vuex'
const tipoOutrasAtividades = require('@/utils/tipoOutrasAtividades').default

export default {

  props: {
    listagem: {
      type: Array,
      required: true
    },
    tipoCodigoAtividade: {
      type: String,
      required: true
    }

  },

  methods: {
    ...mapActions('retificacao', ['update']),
    handleDelete (index, tipoAtividade) {
      this.listagem.splice(index, 1)
      this.$emit('deletaItemLista', this.tipoCodigoAtividade, this.listagem)
    },
    formataDesc (row) {
      return row.descricao ? `${row.descTipo} - ${row.descricao}` : row.descTipo
    },
    formataDescOutrasAtividades (row) {
      const tipoText = tipoOutrasAtividades.filter(item => item.codigo === row.tipo)[0].label
      return row.descricao ? `${tipoText} - ${row.descricao}` : tipoText
    },
    formatarAreaEdificacao (row) {
      const areaFormatada = row.area.toString().replace('.', ',')
      return this.tipoCodigoAtividade === 'EDIFICACOES' ? `${areaFormatada} ${row.descUnidadeArea}` : `${areaFormatada} hectare(s)`
    }
  }
}

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppTableListagemAtividades.vue